import { create } from 'zustand';

export const useIncidentStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    selectedItem: null,
    isFormOpen: false,
    isEditMode: false,
    searchParams: {
        page: 1,
        pageSize: 25,
    },
    paginationData: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 25,
    },
    uniqueValues: {},

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSearchParams: (params) =>
        set((s) => ({ searchParams: { ...s.searchParams, ...params } })),
    setPaginationData: (paginationData) => set({ paginationData }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),
    openCreateForm: () => set({ isFormOpen: true, isEditMode: false, selectedItem: null, error: null }),
    openEditForm: (item) => set({ isFormOpen: true, isEditMode: true, selectedItem: item, error: null }),
    closeForm: () => set({ isFormOpen: false, isEditMode: false, selectedItem: null }),
}));
